import { API_URL } from "../Config";
import { FetchResponse } from "../FetchResponse";

export interface IEts {
  permit_id: string;
  operator_name: string;
  installation_name: string;
  reg_number: string;
  document_link: string;
}

export interface IEtsResponse {
  response: FetchResponse;
  ets?: IEts;
}

export const GetEtsFetchUrl = (
  pageNo: number,
  recordsPerPage: number,
  filters: any
) => {
  let url = `${API_URL}/Permit`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/ets-licences`;
  }

  return url;
};
